import { render, staticRenderFns } from "./side-nav-store.vue?vue&type=template&id=5776d4e0&scoped=true"
import script from "./side-nav-store.vue?vue&type=script&lang=js"
export * from "./side-nav-store.vue?vue&type=script&lang=js"
import style0 from "./side-nav-store.vue?vue&type=style&index=0&id=5776d4e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5776d4e0",
  null
  
)

export default component.exports